import { render, staticRenderFns } from "./RiskProfileCard.vue?vue&type=template&id=cf5cff34&scoped=true"
import script from "./RiskProfileCard.vue?vue&type=script&lang=js"
export * from "./RiskProfileCard.vue?vue&type=script&lang=js"
import style0 from "./RiskProfileCard.vue?vue&type=style&index=0&id=cf5cff34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5cff34",
  null
  
)

export default component.exports